import React from 'react';
import { cn } from '@/lib/utils';

interface MediaUnavailableProps {
  className?: string;
}

export const MediaUnavailable: React.FC<MediaUnavailableProps> = ({ className }) => {
  return <div className={cn('w-full h-full', className)} aria-hidden />;
};
